/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { MachinesMachinePricing } from '../models';
// @ts-ignore
import { MachinesMachines } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * MachinesApi - axios parameter creator
 * @export
 */
export const MachinesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of all available pools
         * @summary heads (pools)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeads: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/heads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns user associated machines usage data
         * @summary Machines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachines: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/machines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get pricing for each model for each machine based on collected statistics
         * @summary Machines models pricing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachinesPricing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/machines_pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MachinesApi - functional programming interface
 * @export
 */
export const MachinesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MachinesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a list of all available pools
         * @summary heads (pools)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHeads(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeads(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MachinesApi.getHeads']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns user associated machines usage data
         * @summary Machines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMachines(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MachinesMachines>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMachines(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MachinesApi.getMachines']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get pricing for each model for each machine based on collected statistics
         * @summary Machines models pricing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMachinesPricing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: MachinesMachinePricing; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMachinesPricing(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MachinesApi.getMachinesPricing']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MachinesApi - factory interface
 * @export
 */
export const MachinesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MachinesApiFp(configuration)
    return {
        /**
         * Retrieve a list of all available pools
         * @summary heads (pools)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeads(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getHeads(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns user associated machines usage data
         * @summary Machines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachines(options?: RawAxiosRequestConfig): AxiosPromise<MachinesMachines> {
            return localVarFp.getMachines(options).then((request) => request(axios, basePath));
        },
        /**
         * Get pricing for each model for each machine based on collected statistics
         * @summary Machines models pricing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachinesPricing(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: MachinesMachinePricing; }> {
            return localVarFp.getMachinesPricing(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MachinesApi - interface
 * @export
 * @interface MachinesApi
 */
export interface MachinesApiInterface {
    /**
     * Retrieve a list of all available pools
     * @summary heads (pools)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachinesApiInterface
     */
    getHeads(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * Returns user associated machines usage data
     * @summary Machines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachinesApiInterface
     */
    getMachines(options?: RawAxiosRequestConfig): AxiosPromise<MachinesMachines>;

    /**
     * Get pricing for each model for each machine based on collected statistics
     * @summary Machines models pricing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachinesApiInterface
     */
    getMachinesPricing(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: MachinesMachinePricing; }>;

}

/**
 * MachinesApi - object-oriented interface
 * @export
 * @class MachinesApi
 * @extends {BaseAPI}
 */
export class MachinesApi extends BaseAPI implements MachinesApiInterface {
    /**
     * Retrieve a list of all available pools
     * @summary heads (pools)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachinesApi
     */
    public getHeads(options?: RawAxiosRequestConfig) {
        return MachinesApiFp(this.configuration).getHeads(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns user associated machines usage data
     * @summary Machines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachinesApi
     */
    public getMachines(options?: RawAxiosRequestConfig) {
        return MachinesApiFp(this.configuration).getMachines(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get pricing for each model for each machine based on collected statistics
     * @summary Machines models pricing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachinesApi
     */
    public getMachinesPricing(options?: RawAxiosRequestConfig) {
        return MachinesApiFp(this.configuration).getMachinesPricing(options).then((request) => request(this.axios, this.basePath));
    }
}

